const referralProgramES = {
	title: "Programa de Referidos de Sin Fila",
	tagline: "Comparte Sin Fila. Todos ganan.",

	howItWorks: {
		heading: "Cómo funciona",
		text: "Todo negocio nuevo recibe 14 días gratis al unirse a Sin Fila. Cuando refieres a alguien usando tu código único, eso se convierte en algo mejor para ambos.",
	},

	ifYouRefer: {
		heading: "Si refieres un negocio",
		text: "Sin límite. Sin trucos. $15 USD de crédito cada vez que alguien que refieras haga su primer pago.",
		bullets: [
			"Sin límite — refiere tantos negocios como quieras, y gana $15 USD por cada uno.",
			"Tu recompensa se aplica automáticamente a tu cuenta.",
		],
	},

	ifYouWereReferred: {
		heading: "Si fuiste referido",
		text: "Obtienes 2 semanas extra gratis — 28 días en total en lugar de 14 — para que tengas más tiempo de probar Sin Fila antes de que se te cobre algo.",
	},

	howToRefer: {
		heading: "Cómo referir a alguien",
		steps: [
			"Encuentra tu código de referido en tu cuenta.",
			"Compártelo con un dueño de negocio que conozcas.",
			"Lo ingresan al registrarse (o dentro de sus primeros 14 días).",
			"Una vez que hagan su primer pago, tu recompensa de $15 USD se agrega a tu cuenta.",
		],
	},

	goodToKnow: {
		heading: "Bueno saberlo",
		bullets: [
			"Las recompensas se acreditan solo después de que tu referido haga su primer pago.",
			"Si tu recompensa es mayor que tu próxima factura, el saldo restante se traslada automáticamente a facturas futuras.",
			"Si aún no te has suscrito, las recompensas que hayas ganado siguen siendo válidas por 6 meses.",
		],
	},

	cta: {
		text: "¿Listo para empezar?",
		button: "Registrar negocio gratis",
	},
};

export default referralProgramES;
